import { render, staticRenderFns } from "./MagnifierSVG.vue?vue&type=template&id=432ea35f&scoped=true"
import script from "./MagnifierSVG.vue?vue&type=script&lang=js"
export * from "./MagnifierSVG.vue?vue&type=script&lang=js"
import style0 from "./MagnifierSVG.vue?vue&type=style&index=0&id=432ea35f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "432ea35f",
  null
  
)

export default component.exports